"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.forwardRefWithStatics = void 0;
var tslib_1 = require("tslib");
var react_1 = require("react");
var hoist_non_react_statics_1 = (0, tslib_1.__importDefault)(require("hoist-non-react-statics"));
function forwardRefWithStatics(component, statics) {
    return (0, hoist_non_react_statics_1.default)((0, react_1.forwardRef)(component), statics);
}
exports.forwardRefWithStatics = forwardRefWithStatics;
